/**
 * 지붕에 찍을 노선번호를 색 두 장에 싣는다.
 *
 * 인스턴스 데이터 텍스처(translation·rotation·color·opacity)에는 빈자리가 없고,
 * 버스는 색 4장 중 color1·color2 를 안 쓴다. 그 6바이트에 글자 코드를 넣는다 -
 * 숫자 0~9 는 0~9, '-' 는 10, 빈칸은 255다. 텍스처에는 글리프 11칸만 굽혀 있고
 * (tools/make-bus-texture.py) 어느 글자를 어디에 놓을지는 셰이더가 정한다.
 *
 * **노선을 추가하면 자동으로 붙는다** - map.js 가 GTFS `routes.txt` 의
 * `route_short_name` 을 그대로 넘긴다. 피드 쪽에서 할 일은 없다.
 *
 * ⚠️ **글리프는 숫자·'-'·영문 대문자뿐이다** (2026-09-14 에 A~Z 를 넣었다.
 * 그전에는 'M4101' 이 통째로 안 찍혔다). 한글·소문자 이후 글자처럼 지원하지 않는
 * 글자가 하나라도 섞이면 그 글자만 빼고 찍는 게 아니라 **번호를 통째로 안 찍는다.**
 * 'M4101' 을 '4101' 로 찍으면 화면이 자신 있게 틀린 번호를 말하게 된다 - 없는
 * 것이 틀린 것보다 낫다.
 *
 * 코드값 순서는 tools/make-bus-texture.py 의 `GLYPHS` 와 같아야 한다
 * (0~9 -> 0~9, '-' -> 10, A~Z -> 11~36). 한쪽만 바꾸면 다른 글자가 찍힌다.
 *
 * @param {string} shortName - 노선번호
 * @returns {Array<string>} [color1, color2] 16진 색 문자열
 */
export function encodeRoofNumber(shortName) {
    // 대문자 글리프만 굽혀 있다. 소문자는 통째로 안 찍느니 올려 찍는다.
    const chars = String(shortName || '').toUpperCase(),
        codes = [255, 255, 255, 255, 255, 255],
        hex = v => v.toString(16).padStart(2, '0'),
        blank = ['#ffffff', '#ffffff'];

    // 6자를 넘으면 자르지 않고 **안 찍는다** (자르면 다른 번호가 된다).
    if (!chars || chars.length > 6) {
        return blank;
    }
    for (let i = 0; i < chars.length; i++) {
        const c = chars[i];

        if (c >= '0' && c <= '9') {
            codes[i] = c.charCodeAt(0) - 48;
        } else if (c === '-') {
            codes[i] = 10;
        } else if (c >= 'A' && c <= 'Z') {
            codes[i] = 11 + c.charCodeAt(0) - 65;
        } else {
            return blank;       // 지원하지 않는 글자가 하나라도 있으면 안 찍는다
        }
    }
    return [
        `#${hex(codes[0])}${hex(codes[1])}${hex(codes[2])}`,
        `#${hex(codes[3])}${hex(codes[4])}${hex(codes[5])}`
    ];
}
